/**
 * The one chevron of the landing page: the lucide "chevron-down" path, drawn
 * with `currentColor`. It is never a text glyph. CSS turns it (see
 * `theme.css`), and `prefers-reduced-motion` switches the turn off.
 *
 * - `disclosure`: points right when closed, down when open (accordion rows).
 * - `menu`: points down when closed, up when open (menu buttons).
 */

/** The two ways the chevron turns. */
export type ChevronKind = 'disclosure' | 'menu'

const SVG_NAMESPACE = 'http://www.w3.org/2000/svg'

/** The lucide chevron-down path. */
export const CHEVRON_PATH = 'm6 9 6 6 6-6'

/** Builds the chevron. It is decorative, so screen readers skip it. */
export const createChevron = (kind: ChevronKind): SVGSVGElement => {
  const icon = document.createElementNS(SVG_NAMESPACE, 'svg')
  icon.setAttribute('class', `chevron chevron-${kind}`)
  icon.setAttribute('viewBox', '0 0 24 24')
  icon.setAttribute('width', '1em')
  icon.setAttribute('height', '1em')
  icon.setAttribute('fill', 'none')
  icon.setAttribute('stroke', 'currentColor')
  icon.setAttribute('stroke-width', '2.5')
  icon.setAttribute('stroke-linecap', 'round')
  icon.setAttribute('stroke-linejoin', 'round')
  icon.setAttribute('aria-hidden', 'true')
  icon.setAttribute('focusable', 'false')
  const path = document.createElementNS(SVG_NAMESPACE, 'path')
  path.setAttribute('d', CHEVRON_PATH)
  icon.append(path)
  return icon
}
